import {Action} from '@ngrx/store';
import {Deserialize, Serialize} from 'cerialize';
import {GetBijbEventAction} from '../actions/bijb-event/get-event-action';
import {BijbEventState} from '../states/bijb-event-state';
import {GetBijbEventSuccessAction} from '../actions/bijb-event/get-event-success-action';
import {GetBijbEventErrorAction} from '../actions/bijb-event/get-event-error-action';
import {UpdateBijbEventAction} from '../actions/bijb-event/update-event-action';
import {UpdateBijbEventErrorAction} from '../actions/bijb-event/update-event-error-action';
import {AddBijbEventAction} from '../actions/bijb-event/add-event-action';
import {AddBijbEventErrorAction} from '../actions/bijb-event/add-event-error-action';

const initialState = new BijbEventState();

export function BijbEventReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: BijbEventState = Deserialize(serializedState, BijbEventState);

  switch (action.type) {
    case AddBijbEventAction.type:
      state.ready = false;
      state.error = null;
      break;

    case AddBijbEventErrorAction.type:
      state.ready = true;
      state.error = (<AddBijbEventErrorAction>action).error;
      break;

    case GetBijbEventAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetBijbEventSuccessAction.type:
      state.ready = true;
      state.bijbEvent = (<GetBijbEventSuccessAction>action).bijbEvent;
      state.error = null;
      break;

    case GetBijbEventErrorAction.type:
      state.ready = true;
      state.bijbEvent = null;
      state.error = (<GetBijbEventErrorAction>action).error;
      break;

    case UpdateBijbEventAction.type:
      state.ready = false;
      state.error = null;
      break;

    case UpdateBijbEventErrorAction.type:
      state.ready = true;
      state.error = (<UpdateBijbEventErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
